import React from 'react';
import ProductCategoryPage from '../../components/ProductsList/ProductCategoryPage';
import { guardrailProducts } from '../../data/products';

export default function Guardrail() {
  return (
    <ProductCategoryPage
      title="도로 안전유도시설"
      subtitle={"도로 작업자 및 운전자의 안전한 대피를 돕고, \n차량의 안전한 통행을 유도합니다"}
      products={guardrailProducts}
    />
  );
}
